export default __webpack_public_path__ + "static/travelexp-screenshot-d34500276611677ae7f1a0c30308a0d7.png";